import * as ReactDOM from 'react-dom';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import styled from 'styled-components';
import { light, white } from '../theme/colors';

const StepperWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: ${white};
  justify-content: space-between;
  z-index: 2000;
  border-top: 1px solid ${light};
  border-bottom: 1px solid ${light};
  padding: 0;

  @media screen and (max-width: 780px) {
    padding: 0 30px;
  }

  @media screen and (max-width: 575px) {
    padding: 0 15px;
  }
`;

const StepperContainer = styled.div`
  width: 100%;
  max-width: 720px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;

  .btn {
    width: 260px;

    @media screen and (max-width: 767px) {
      &:first-child {
        width: 42px;

        .fa-chevron-left {
          margin-right: 2px;
        }
      }

      &:last-child {
        width: auto;
        font-size: 13px;
        min-width: 180px;
      }
    }

    &:first-child {
      background-color: ${light};
      border: ${light};
    }
  }
`;

const NetZeroFooter = ({
  onShowPrev,
  onShowNext,
  nextButtonLabel,
  currentStepCount,
}) => {
  const portal = document.getElementById('portal');
  return ReactDOM.createPortal(
    <StepperWrapper>
      <StepperContainer>
        <Button
          onClick={onShowPrev}
          className="background-color-light color-white">
          <span className="d-none d-md-inline">Back</span>
          <span className="d-md-none d-sm-inline">
            <FontAwesomeIcon icon={faChevronLeft} />
          </span>
        </Button>
        <Button onClick={onShowNext}>Next: {nextButtonLabel}</Button>
      </StepperContainer>
    </StepperWrapper>,
    portal,
  );
};

export default NetZeroFooter;
